import React, { useState, useEffect } from 'react';
import NewPostTags from './NewPostTags';
import defaultProfileImg from './images/plotlogo.svg';
import Messenger from './Messenger';
import haversineDistance from 'haversine-distance';
import { getStorage, ref as storageRef, deleteObject } from 'firebase/storage';
import { getDatabase, set, get, ref, update, remove, onValue } from 'firebase/database';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { AiOutlineClose } from "react-icons/ai";
import { FaUserSlash } from "react-icons/fa";
import {
    BrowserRouter as Router,

    Link,
 
  } from "react-router-dom";
  import plantimg from "./images/bioplant.png";
  import bird from "./images/BIRD.svg";
import panda from "./images/PANDA.svg";
import rabbit from "./images/RABBIT.svg";
import pig from "./images/PIG.svg";
import fox from "./images/FOX.svg";
import bear from "./images/BEAR.svg";
import crow from "./images/CROW.svg";
import cow from "./images/COW.svg";
import snail from "./images/SNAIL.svg";
import penguin from "./images/PENGUIN.svg";
import frog from "./images/FROG.svg";
import raccoon from "./images/RACCOON.svg";
import zebra from "./images/ZEBRA.svg";
import elephant from "./images/ELEPHANT.svg";
import axolotl from "./images/AXOLOTL.svg";

function Farmposts({ setShowUserProfile, showCreatePostForm, setShowCreatePostForm, setShowFarmposts, setCurrentPage, selectedConversation, setSelectedConversation, user, setShowLoginModal, setSelectedUserProfile, selectedUserProfile, posts, setPosts, setMobileConversationView, mobileConversationView, setIsLoading, showMessenger ,setShowMessenger, isMessengerVisible, setIsMessengerVisible, userLocation, setUserLocation}) {
    const [editMode, setEditMode] = useState(false);
    const [editData, setEditData] = useState({});
    const [selectedTags, setSelectedTags] = useState([]);
    const [isOverlayVisible, setOverlayVisible] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);
const [expandedPostId, setExpandedPostId] = useState(null);
const [selectedPost, setSelectedPost] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const [usernameSearch, setUsernameSearch] = useState('');
const [selectedDistance, setSelectedDistance] = useState(null);
// const [userLocation, setUserLocation] = useState(null);
const [selectedSearchTags, setSelectedSearchTags] = useState([]);
const [isSearchVisible, setIsSearchVisible] = useState(false);
const [sortMethod, setSortMethod] = useState('nearest');
const [loadedImages, setLoadedImages] = useState([]);
const [zipCode, setZipCode] = useState('');
const [isDataLoaded, setIsDataLoaded] = useState(false);
const [toBeDeleted, setToBeDeleted] = useState(null);
const [showProfileOverlay, setShowProfileOverlay] = useState(false);
const [showProfileBlockConfirm, setShowProfileBlockConfirm] = useState(false);
const [blockedUsersState, setBlockedUsersState] = useState([]);




    const auth = getAuth();
    const currentUser = auth.currentUser;
    const db = getDatabase();

    const fetchUserProfile = async (uid) => {
        const userProfileRef = ref(db, `users/${uid}`);
        const snapshot = await get(userProfileRef);
        return snapshot.val();
    };

    const handleUsernameClick = async (uid) => {
        const userRef = ref(getDatabase(), `users/${uid}`);
        const userSnapshot = await get(userRef);
    
        if (userSnapshot.exists()) {
            setSelectedUserProfile(userSnapshot.val());
            setShowProfileOverlay(true);
        }
    };


    const profileImages = [
        bird, panda, rabbit, pig, fox, bear, crow, cow, snail, penguin,
        frog, raccoon, zebra, elephant, axolotl
      ];

      function getUserIdHash(userId) {
        let hash = 0;
        for (let i = 0; i < userId.length; i++) {
            const char = userId.charCodeAt(i);
            hash = ((hash << 5) - hash) + char; // Left shift and add char
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    
    function getDefaultProfileImgForUser(userId) {
        const index = Math.abs(getUserIdHash(userId)) % profileImages.length;
        return profileImages[index];
    }
    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setIsLoading(true);
                const db = getDatabase();
                const userRef = ref(db, `users/${user.uid}`);
                const snapshot = await get(userRef);
                
    
                if (snapshot.exists()) {
                    const userData = snapshot.val();
                    setUserLocation(userData.location || null);
                    setIsDataLoaded(true);
                } else {
                    console.log("Snapshot doesn't exist for user: ", user.uid);
                    setIsDataLoaded(true);
                }
                setIsLoading(false);
            } else {
                console.log("User is not logged in or not available at the moment");
                setIsDataLoaded(true);
            }
        });
    
        // Cleanup function to unsubscribe from the listener when the component unmounts
        return () => unsubscribe();
    }, []);

  
    
    const handleBlockUserFromProfileOverlay = async () => {
        
    
        const userToBlockId = selectedUserProfile.uid;
    
        // Hide all conversations with the user to block
        const conversationsRef = ref(db, 'conversations');
        const conversationsSnapshot = await get(conversationsRef);
        const conversationsData = conversationsSnapshot.val();
    
        if (conversationsData) {
            for (let convoKey in conversationsData) {
                const convo = conversationsData[convoKey];
                if (convo.participant1 === userToBlockId || convo.participant2 === userToBlockId) {
                    const userHiddenConvosRef = ref(db, `users/${currentUser.uid}/hiddenConversations/${convoKey}`);
                    set(userHiddenConvosRef, true);
                }
            }
        }
    
        setShowProfileOverlay(false);
    };



    const contactUserFromProfileOverlay = async () => {
        if (!user) {
            setShowLoginModal(true);
            return;
        }
    
        const recipientId = selectedUserProfile.uid;
    
        // Fetch all conversations from the 'conversations' node
        const conversationsRef = ref(db, 'conversations');
        const conversationsSnapshot = await get(conversationsRef);
        const conversationsData = conversationsSnapshot.val();
    
        let existingConversation = null;
    
        if (conversationsData) {
            for (let convoKey in conversationsData) {
                const convo = conversationsData[convoKey];
                if ((convo.participant1 === currentUser.uid && convo.participant2 === recipientId) || 
                    (convo.participant1 === recipientId && convo.participant2 === currentUser.uid)) {
                    existingConversation = {
                        id: convoKey,
                        ...convo
                    };
                    break;
                }
            }
        }
    
        if (existingConversation) {
            setSelectedConversation(existingConversation);
        } else {
            // If no conversation exists, set a "ghost" conversation
            setSelectedConversation({
                isGhost: true, // a flag to indicate it's not a real conversation in the database
                participant1: currentUser.uid,
                participant2: recipientId
            });
        }
    
        setCurrentPage('messenger');
        setIsMessengerVisible(true);
        setShowMessenger(true);
        setMobileConversationView(false);
    };
    
    function arraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }


 const handleContactGrower = async (post) => {
    if (!user) {
        setShowLoginModal(true);
        return;
    }

    const recipientId = post.uid;

    // Fetch all conversations from the 'conversations' node
    const conversationsRef = ref(db, 'conversations');
    const conversationsSnapshot = await get(conversationsRef);
    const conversationsData = conversationsSnapshot.val();

    let existingConversation = null;

    if (conversationsData) {
        for (let convoKey in conversationsData) {
            const convo = conversationsData[convoKey];
            if ((convo.participant1 === currentUser.uid && convo.participant2 === recipientId) || 
                (convo.participant1 === recipientId && convo.participant2 === currentUser.uid)) {
                existingConversation = {
                    id: convoKey,
                    ...convo
                };
                break;
            }
        }
    }

    if (existingConversation) {
        setSelectedConversation(existingConversation);
    } else {
        // If no conversation exists, set a "ghost" conversation
        setSelectedConversation({
            isGhost: true, // a flag to indicate it's not a real conversation in the database
            participant1: currentUser.uid,
            participant2: recipientId
        });
    }

    // Fetch the user data using fetchUserProfile function
    const userProfile = await fetchUserProfile(recipientId);

    if (userProfile) {
        setSelectedUserProfile(userProfile);
    } else {
        console.error("No user found for this UID");
    }
    setCurrentPage('messenger');
    setSelectedPost(post);
    setIsMessengerVisible(true);
    setShowMessenger(true);
    setMobileConversationView(false);
};

    
    
    const closeMessenger = () => {
        setIsMessengerVisible(false);
        setSelectedPost(null);
        setShowMessenger(false);
    }

    const possibleTags = [
        "organic", "you-pick", "washed",
         "pesticide-free", "non-GMO",
        "heirloom", "harvested",
        "locally-sourced", "permaculture", "biodynamic",
        "seasonal"
    ];

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            const currentLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            setUserLocation(currentLocation);
          
          }, (error) => {
            console.error("Error fetching location", error);
          });
        } else {
          console.error("Geolocation is not supported by this browser.");
        }
      };




    const handleImageLoad = (url) => {
        setLoadedImages(prevLoaded => {
            if(!prevLoaded.includes(url)) {
                return [...prevLoaded, url];
            }
            return prevLoaded;
        });
    };

    const showImageOverlay = (imgUrl) => {
        setSelectedImage(imgUrl);
        setOverlayVisible(true);
    };
    
    const closeImageOverlay = () => {
        setOverlayVisible(false);
        setSelectedImage(null);
    };

    const toggleExpanded = (postId) => {
        if (expandedPostId === postId) {
            setExpandedPostId(null);
            setToBeDeleted(null); // Collapse if the post is already expanded
        } else {
            setExpandedPostId(postId); // Expand the clicked post
        }
    };

   

    const fetchZipCodeLocation = async () => {
        try {
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`);

            const data = await response.json();
    
            if (data.results && data.results.length > 0) {
                const location = data.results[0].geometry.location;
                setUserLocation(location);
            } else {
                console.error('Unable to fetch location for the given ZIP code.');
            }
        } catch (error) {
            console.error('Error fetching ZIP code location:', error);
        }
    };


    
    const toggleSearchTag = (tag) => {
        setSelectedSearchTags(prevTags => {
            if (prevTags.includes(tag)) {
                // If tag is already selected, remove it
                return prevTags.filter(t => t !== tag);
            } else {
                // Otherwise, add it
                return [...prevTags, tag];
            }
        });
    };


    const calculateDistance = (userLoc, postLoc) => {
        if (
            userLoc && 
            postLoc && 
            'lat' in userLoc && 
            'lng' in userLoc && 
            'lat' in postLoc && 
            'lng' in postLoc
        ) {
            const distanceMeters = haversineDistance(userLoc, postLoc);
            const distanceMiles = distanceMeters / 1609.34;  // Convert meters to miles
            return Math.round(distanceMiles);  // Round to the nearest whole mile
        }
        return null;
    };

 
const handleEdit = (post) => {
    setEditData(post);
    setSelectedTags(post.tags || []);
    setEditMode(true);
  }
  
  const removeImage = (idx) => {
    const newImages = [...editData.imageUrls];
    newImages.splice(idx, 1);
    setEditData(prevData => ({ ...prevData, imageUrls: newImages }));
  };

  const handleImageChange = (e) => {
    // Handle the addition of new images to existing ones during edit
    // Note: Implement this based on your image handling mechanism
  };

 

  const handleSaveEdit = async () => {
    const db = getDatabase();
    const postRef = ref(db, `farmposts/${editData.id}`);
    await update(postRef, {
      title: editData.title,
      description: editData.description,
      // ... any other fields you want to edit
    });
    setEditMode(false);
  }

  const filteredPosts = posts.filter(post => {
    const postDistance = calculateDistance(userLocation, post.location);
    const omniMatch = searchTerm.toLowerCase();
    
    const omniSearch = 
        post.title.toLowerCase().includes(omniMatch) ||
        (post.description && post.description.toLowerCase().includes(omniMatch)) ||
        post.username.toLowerCase().includes(omniMatch) ||
        (Array.isArray(post.tags) && post.tags.some(tag => typeof tag === 'string' && tag.toLowerCase().includes(omniMatch)));

    const titleMatch = post.title.toLowerCase().includes(searchTerm.toLowerCase());
    const usernameMatch = post.username.toLowerCase().includes(usernameSearch.toLowerCase());
    const distanceMatch = selectedDistance === null || (postDistance !== null && postDistance <= selectedDistance);
    
    const tagsMatch = selectedSearchTags.length === 0 || 
        (Array.isArray(post.tags) && selectedSearchTags.some(tag => post.tags.includes(tag)));

    return (omniSearch || (titleMatch && usernameMatch)) && distanceMatch && tagsMatch;
});

const sortedPosts = [...filteredPosts].sort((a, b) => {
    if (sortMethod === 'nearest') {
        const distanceA = calculateDistance(userLocation, a.location);
        const distanceB = calculateDistance(userLocation, b.location);
        return distanceA - distanceB; // Ascending order based on distance
    } else if (sortMethod === 'recent') {
        return new Date(b.timestamp) - new Date(a.timestamp); // Descending order based on timestamp
    }
});

useEffect(() => {
    const preloadImage = new Image();
    preloadImage.src = plantimg;
}, []);

const handleDelete = async (postId) => {
    if (toBeDeleted !== postId) {
        // If clicked for the first time, just show the confirmation prompt
        setToBeDeleted(postId);
    } else {
        const db = getDatabase();
        const postRef = ref(db, `farmposts/${postId}`);
        await remove(postRef);
        setToBeDeleted(null); // Reset the state after deletion
    }
};

const handleBlockUser = async (blockedUserId) => {
    // Add the user to the user's blockedUsers list
    const userBlockedUsersRef = ref(db, `users/${currentUser.uid}/blockedUsers/${blockedUserId}`);
    await set(userBlockedUsersRef, true);
    
    // Update the blocked users state
    setBlockedUsersState(prevState => [...prevState, blockedUserId]);
};


useEffect(() => {
    setIsLoading(true);
    const db = getDatabase();
    
    const fetchBlockedUsers = async () => {
        if (!currentUser) return [];  // Return an empty list if there's no current user
    
        const blockedUsersRef = ref(db, `users/${currentUser.uid}/blockedUsers`);
        const snapshot = await get(blockedUsersRef);
        
        const blockedUserIds = [];
        if (snapshot.exists()) {
            const blockedUsers = snapshot.val();
            for (let blockedUserId in blockedUsers) {
                blockedUserIds.push(blockedUserId);
            }
        }
        return blockedUserIds;
    };

    fetchBlockedUsers().then((blockedUserIds) => {
        if (!arraysEqual(blockedUserIds, blockedUsersState)) {
            setBlockedUsersState(blockedUserIds);
        }
        
        const postsRef = ref(db, 'farmposts');
        const unsubscribePosts = onValue(postsRef, (snapshot) => {
            const data = snapshot.val();
            const allPosts = [];
            for (let id in data) {
                if (!blockedUserIds.includes(data[id].uid)) { // Only add the post if the user isn't blocked
                    allPosts.push({ id, ...data[id] });
                }
            }
            setPosts(allPosts);
            setIsLoading(false);
        });

        if (currentUser) {
            // If there's a logged-in user, fetch their saved location
            const userLocationRef = ref(db, `users/${currentUser.uid}/location`);
            const unsubscribeUserLocation = onValue(userLocationRef, (snapshot) => {
                const location = snapshot.val();
                if (location && (location.lat !== userLocation?.lat || location.lng !== userLocation?.lng)) {
                    setUserLocation(location);
                }
            });

            return () => {
                unsubscribePosts();
                unsubscribeUserLocation();
            };
        } else {
            // Only return the unsubscribePosts cleanup function if there's no currentUser
            return unsubscribePosts;
        }
    });
    
}, [currentUser, userLocation, blockedUsersState]);



// useEffect(() => {
//     const totalImages = posts.reduce((count, post) => count + (post.imageUrls ? post.imageUrls.length : 0), 0);
//     if (loadedImages.length === totalImages) {
//         setIsLoading(false);
//     }
// }, [loadedImages, posts]);

if (!isDataLoaded) {
    return <div className="farmposts_size_container">
    <div className="farmposts_master_container"></div></div>;
  }

    return (
        <div className="farmposts_size_container">
            



           {!isMessengerVisible && 
        <div className="farmposts_master_container">



{
    showProfileOverlay && selectedUserProfile && 
    <div className="overlay">
        
        {(() => {
                    console.log(selectedUserProfile.uid)
                    const otherParticipantId = selectedUserProfile?.uid;
                    const defaultProfileImg = getDefaultProfileImgForUser(otherParticipantId);
                    
                    return (
        
        <div className="profile_overlay_container_master">
        
        <div className={!showProfileBlockConfirm ? "border_accent_div_green" : "border_accent_div_red"}></div>

        {!showProfileBlockConfirm &&
        <div className="profile_overlay_container" style={{ backgroundImage: `url(${plantimg})` }} >
        
        <div className="profile_overlay_container_close_button_container"><button className="profile_overlay_container_close_button" onClick={() => setShowProfileOverlay(false)}><AiOutlineClose /></button></div>
        <img className={selectedUserProfile.profilePicURL ? "profile_overlay_profile_pic" : "profile_overlay_profile_pic_default"} src={selectedUserProfile.profilePicURL ? selectedUserProfile.profilePicURL : defaultProfileImg} alt={`${selectedUserProfile.username} profile`} />
        <h2 className="profile_overlay_username">{selectedUserProfile.username}</h2>
        <p className="profile_overlay_description">{selectedUserProfile.description}</p>
        
        {user && selectedUserProfile.uid === currentUser.uid ? (
            <Link to="/profile">
                <button 
                    className="profile_overlay_view_profile_button" 
                    onClick={() => {
                        setShowUserProfile(true);
                        setCurrentPage('profile');
                        setShowFarmposts(false);
                        setShowMessenger(false);
                        setMobileConversationView(false);
                        setIsMessengerVisible(false);
                        setSelectedUserProfile(null);
                        setShowProfileBlockConfirm(false);
                    }}>
                    View Your Profile
                </button>
            </Link>
        ) : user ? (
            <Link to="/messenger"
                  className="profile_overlay_message_button" 
                  onClick={() => {
                      contactUserFromProfileOverlay();
                      setShowProfileOverlay(false);
                  }}>
                Send Message
            </Link>
        ) : (
            <button 
                className="profile_overlay_message_button" 
                onClick={() => {
                    setShowLoginModal(true);
                }}>
                Send Message
            </button>
        )}

        {user && selectedUserProfile.uid !== currentUser.uid && (
            <button 
                className="profile_overlay_block_button" 
                onClick={() => {
                    setShowProfileBlockConfirm(true);
                }}>
                Block User
            </button>
        )}
        
    </div>}
    
    {showProfileBlockConfirm && <div className="profile_block_user_confirmation_container">
    <div className="profile_block_user_confirmation"><div className="profile_block_user_icon"><FaUserSlash /></div>
    {`Are you sure you want to block ${selectedUserProfile.username}? You can manage blocked users in your profile.`}
</div>

    <div className="profile_block_user_confirmation_button_container">

    <button className="profile_block_user_confirmation_block_button" onClick={() => {
    handleBlockUser(selectedUserProfile.uid);
    setShowProfileBlockConfirm(false);
    setShowProfileOverlay(false); // Close the overlay after blocking
}}>Block User</button>
    <button className="profile_block_user_confirmation_cancel_button" onClick={() => {
                    setShowProfileBlockConfirm(false);
                }} >Cancel</button>

    </div>
    </div>}





    </div> );
                })()}
    </div>
}



 
           

          
{isSearchVisible && ( <div className="farmposts_search_container"><div className="farmposts_search_term_container">
   {/* <input 
   className="farmposts_title_search"
    type="text" 
    placeholder="Search by produce..." 
    value={searchTerm}
    onChange={e => setSearchTerm(e.target.value)} 
/> */}
<select 
className="farmposts_distance_search"
    value={selectedDistance || ''}
    onChange={e => setSelectedDistance(e.target.value ? parseInt(e.target.value, 10) : null)}
>
    <option value="">Any distance</option>
    <option value="1">1 mile</option>
    <option value="2">2 miles</option>
    <option value="5">5 miles</option>
    <option value="10">10 miles</option>
    <option value="20">20 miles</option>
    <option value="50">50 miles</option>
    <option value="100">100 miles</option>
</select>
<select 
    className="farmposts_sorting_dropdown"
    value={sortMethod}
    onChange={e => setSortMethod(e.target.value)}
>
    <option value="nearest">Nearest</option>
    <option value="recent">Most Recent</option>
</select></div>
<div className="farmposts_search_term_container">
{/* <input 
className="farmposts_username_search"
    type="text" 
    placeholder="Search by grower..." 
    value={usernameSearch}
    onChange={e => setUsernameSearch(e.target.value)} 
/> */}

</div>
<div className="farmposts_search_tags">
    {possibleTags.map(tag => (
        <NewPostTags 
            key={tag} 
            name={tag} 
            isSelected={selectedSearchTags.includes(tag)}
            toggleTag={toggleSearchTag}
        />
    ))}
</div>
</div>)}
<div className="farmposts_search_results_title"><input  value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)} maxLength="20" placeholder='Search' className="farmposts_omnisearch"></input><button className="farmposts_show_or_hide_search" onClick={() => setIsSearchVisible(prev => !prev)}>
    {isSearchVisible ? 'Hide Filter' : 'Show Filter'}
</button></div>


 <div>
      {userLocation && sortedPosts.map(post => {
          const postDistance = calculateDistance(userLocation, post.location);
          return (
              <div className="farmposts_individual_post_container" key={post.id}>
                  <div className="farmposts_post_header_container">
                      <div className="farmposts_post_header_title_pricing">
                          <div className="farmposts_post_title">{post.title}</div>
                          <div className={post.pricing === "Trade" ? "farmposts_post_pricing_trade" : "farmposts_post_pricing_free"}>{post.pricing}</div>
                          <div className="farmposts_post_distance">
                              {postDistance !== null ? 
                                  (postDistance === 0 ? "<1 mile" :
                                      (postDistance === 1 ? "~1 mile" : `~${postDistance} miles`)) : 
                                  ''}
                          </div>
                      </div>
                      <div onClick={() => handleUsernameClick(post.uid)} className="farmposts_post_farmer">{post.username}</div>
                  </div>

                  <div className="farmposts_thumbnails_container">
                      <div className="farmposts_thumbnails_scroller_container">
                          {post.imageUrls && post.imageUrls.map((url, idx) => (
                              <div
                                  key={idx}
                                  style={{ backgroundImage: `url(${url})` }}
                                  className="thumbnail"
                                  onClick={() => showImageOverlay(url)}
                                  aria-label={`${post.title} ${idx + 1}`} // for accessibility
                                  role="img" // for accessibility
                              >
                                  {/* Add an img tag to trigger onLoad */}
                                  <img src={url} alt={`${post.title} ${idx + 1}`} style={{display: 'none'}} onLoad={() => handleImageLoad(url)} />
                              </div>
                          ))}
                      </div>
                  </div>

                  <div className="farmposts_byline_container">
                      <div className="farmposts_tags_container">
                          {post.tags && post.tags.slice(0, expandedPostId === post.id ? post.tags.length : 4).map(tag => (
                              <span key={tag} className="farmposts_post_tags">{tag}</span>
                          ))}
                      </div>
                      <div className="farmposts_see_more_button_container">
                          <button 
                              className={expandedPostId === post.id ? "farmposts_post_see_less_button" : "farmposts_post_see_more_button"}
                              onClick={() => toggleExpanded(post.id)}
                          >
                              {expandedPostId === post.id ? "See Less" : "See More"}
                          </button>
                      </div>

                  </div>

                  {expandedPostId === post.id && (
    <div className={expandedPostId === post.id ? "farmposts_post_description_container expanded" : "farmposts_post_description_container"}>
        <div className="farmposts_post_description_title">{post.title}</div>
        <div className="farmposts_post_description">{post.description}</div>
        <div className="farmposts_bottom_footer_container">
            <div className="farmposts_post_contact_farmer_container">
            {
  currentUser ? (
    post.uid === currentUser.uid ? (
      <div>
        {toBeDeleted !== post.id ? (
          <button className="farmposts_post_delete_button" onClick={() => handleDelete(post.id)}>Delete Post</button>
        ) : (
          <button className="farmposts_post_delete_button" onClick={() => handleDelete(post.id)}>Confirm Delete</button>
        )}
      </div>
    ) : (
      <div>
        <Link to="/messenger"><button className="farmposts_post_contact_farmer_button" onClick={() => handleContactGrower(post)}>Send Message</button></Link>
      </div>
    )
  ) : (
    <div>
      <button className="farmposts_post_contact_farmer_button" onClick={() => handleContactGrower(post)}>Send Message</button>
    </div>
  )
}

            </div>
            <div className="farmposts_post_timestamp">Posted {new Date(post.timestamp).toLocaleString()}</div>
        </div>
    </div>
)}

                  {isOverlayVisible && (
                      <div className="overlay" onClick={closeImageOverlay}>
                          <img src={selectedImage} alt="Expanded View" />
                      </div>
                  )}






              </div>
          )
      })}

{userLocation && <div className="farmposts_end_of_list">End of list</div>}

{!userLocation && (
    <div className="farmposts_zip_container">
        <label className="farmposts_zip_code_label" htmlFor="zipcode">Enter a zip code to start searching:</label>
        <div className="farmposts_zip_code_container">
            <input
                className="farmposts_zip_code_input"
                id="zipcode"
                type="text"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
            />
        </div>

        <div className="farmposts_zip_code_submit_container">
            <button 
                className={`farmposts_zip_code_button ${!zipCode.trim() ? "disabled" : ""}`} 
                onClick={fetchZipCodeLocation}
                disabled={!zipCode.trim()}
            >
                Search
            </button>
            <p className="farmposts_zip_code_label">or</p>
            <button type="button" className="google_maps_location_button_farmposts" onClick={getCurrentLocation}>
                Use Current Location
            </button>
        </div>
    </div>
)}

    </div>







        </div>}

        {!showCreatePostForm &&  
  <div className="create_post_button_container">
    { user ? (
      <Link to="/create-post">
        <button className="create_post_button" onClick={() => {
          setShowCreatePostForm(true);
          setShowFarmposts(false);
          setCurrentPage('create-post');
        }}>
          Create New Post
        </button>
      </Link>
    ) : (
      <button className="create_post_button" onClick={() => setShowLoginModal(true)}>
        Create New Post
      </button>
    )}
  </div>
}
        
        
        </div>
    );
}

export default Farmposts;